import { DocContentContextProvider } from 'src/pages/dashboard/DocsPage/DocContent/DocContentContext';
import { useDocQuery } from 'src/pages/dashboard/DocsPage/shared/useDocQuery';
import { TranscriptionRightMenuInner } from '../Transcriptions/RightDrawer/TranscriptionRightMenuDrawer';
import { useDocsActionBarState } from './useDocsActionBarState';

export const DocActionBarDrawer = ({ onClose }: { onClose(): void }) => {
  const { docId } = useDocsActionBarState();

  const { doc } = useDocQuery(docId);

  if (!doc) return null;

  return (
    <DocContentContextProvider doc={doc}>
      <TranscriptionRightMenuInner onClose={onClose} />
    </DocContentContextProvider>
  );
};
